import { api } from "./api";
import { getAdminToken } from "./admin";

const adminHeaders = () => ({ headers: { "X-Admin-Password": getAdminToken() || "" } });

/* ---------------- Stores ---------------- */
export const listStores = async () =>
  (await api.get("/admin/stores", adminHeaders())).data.items || [];
export const createStore = async (payload) =>
  (await api.post("/admin/stores", payload, adminHeaders())).data;
export const updateStore = async (id, patch) =>
  (await api.patch(`/admin/stores/${id}`, patch, adminHeaders())).data;
export const deleteStore = async (id) =>
  (await api.delete(`/admin/stores/${id}`, adminHeaders())).data;

/* ---------------- Templates ---------------- */
export const listTemplates = async () =>
  (await api.get("/admin/email-templates", adminHeaders())).data;
export const createTemplate = async (payload) =>
  (await api.post("/admin/email-templates", payload, adminHeaders())).data;
export const updateTemplate = async (id, patch) =>
  (await api.patch(`/admin/email-templates/${id}`, patch, adminHeaders())).data;
export const deleteTemplate = async (id) =>
  (await api.delete(`/admin/email-templates/${id}`, adminHeaders())).data;

export const uploadAttachments = async (templateId, files, onProgress) => {
  const fd = new FormData();
  for (const f of files) fd.append("files", f);
  const res = await api.post(`/admin/email-templates/${templateId}/attachments`, fd, {
    headers: { ...adminHeaders().headers, "Content-Type": "multipart/form-data" },
    onUploadProgress: (evt) => {
      if (onProgress && evt.total) onProgress(Math.round((evt.loaded * 100) / evt.total));
    },
  });
  return res.data;
};

export const deleteAttachment = async (templateId, attachmentId) =>
  (await api.delete(`/admin/email-templates/${templateId}/attachments/${attachmentId}`, adminHeaders())).data;

export const renderTemplate = async (templateId, storeId) =>
  (await api.get(`/admin/email-templates/${templateId}/render`, {
    ...adminHeaders(),
    params: { store_id: storeId },
  })).data;

/**
 * Trigger a browser download for an attachment via fetch+blob so the admin
 * password header is sent (bare <a href> would 401).
 */
export const downloadAttachment = async (templateId, attachment) => {
  const url = `${api.defaults.baseURL}/admin/email-templates/${templateId}/attachments/${attachment.id}`;
  const res = await fetch(url, { headers: { "X-Admin-Password": getAdminToken() || "" } });
  if (!res.ok) throw new Error(`Download failed (${res.status})`);
  const blob = await res.blob();
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = attachment.filename || "attachment";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
};

/* ---------------- Placeholder catalog (UI hint) ---------------- */
export const PLACEHOLDERS = [
  { key: "store_name", label: "Store name" },
  { key: "store_address", label: "Street address" },
  { key: "store_city_state_zip", label: "City, State Zip" },
  { key: "store_phone", label: "Phone" },
  { key: "store_email", label: "Email" },
  { key: "manager_name", label: "Manager name" },
  { key: "store_signature", label: "Full signature block (auto-built)" },
];
